var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.703 0c-1.9 0-3.64.605-5.175 1.795-1.472 1.142-2.451 2.596-3.028 3.654-.577-1.058-1.556-2.512-3.028-3.654C12.937.605 11.196.001 9.297.001 3.997 0 0 4.35 0 10.118c0 6.23 4.986 10.494 12.535 16.948 1.282 1.096 2.735 2.339 4.245 3.664a1.09 1.09 0 0 0 1.44 0 431.744 431.744 0 0 1 4.246-3.665C30.014 20.612 35 16.35 35 10.118 35 4.35 31.003 0 25.703 0z",
    fill: "#F6B119",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.acd6817f81457a49ae611c006f2db71e.svg";
export { ForwardRef as ReactComponent };